import * as tslib_1 from "tslib";
import { DateTimeFormats_$type } from "./DateTimeFormats";
import { IgrCellInfo } from "./igr-cell-info";
import { DateTimeCellModel as DateTimeCellModel_internal } from "./DateTimeCellModel";
import { ensureEnum, ensureBool } from "igniteui-react-core";
/**
 * Backing information about a date time cell for the grid.
*/
var IgrDateTimeCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrDateTimeCellInfo, _super);
    function IgrDateTimeCellInfo() {
        return _super.call(this) || this;
    }
    IgrDateTimeCellInfo.prototype.createImplementation = function () {
        return new DateTimeCellModel_internal();
    };
    Object.defineProperty(IgrDateTimeCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeCellInfo.prototype, "dateTimeValue", {
        /**
         * Sets or gets the DateTime value for the cell.
        */
        get: function () {
            return this.i.km;
        },
        set: function (v) {
            this.i.km = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeCellInfo.prototype, "formatOverride", {
        /**
         * The format options to apply to the value
        */
        get: function () {
            return this.i.ku;
        },
        set: function (v) {
            this.i.ku = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeCellInfo.prototype, "dateTimeFormat", {
        /**
         * Sets or gets the simple DateTimeFormat to use for the cell.
        */
        get: function () {
            return this.i.ki;
        },
        set: function (v) {
            this.i.ki = ensureEnum(DateTimeFormats_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeCellInfo.prototype, "isOffsetValue", {
        /**
         * Sets or gets whether the value to use is a DateTimeOffset value.
        */
        get: function () {
            return this.i.kk;
        },
        set: function (v) {
            this.i.kk = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrDateTimeCellInfo;
}(IgrCellInfo));
export { IgrDateTimeCellInfo };
//# sourceMappingURL=igr-date-time-cell-info.js.map
